module.exports = __webpack_public_path__ + "img/parsel_tongue.f79c0973.jpg";